export const allowedMenuNames = ["Home", "Trainings", "Govt. Circulars/GR", "Articles"];
